var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mCircularProgressRootBox" }, [
    _c("div", { staticClass: "circularRootBox" }, [
      _c("div", { staticClass: "waterBox" }, [
        _c(
          "div",
          {
            staticClass: "num",
            style: { color: _vm.score >= 65 ? "#ffffff" : null },
            attrs: { "data-company": _vm.suffix }
          },
          [_vm._v(_vm._s(_vm.score))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "water",
            style: {
              "--top": (100 - _vm.score < 0 ? 0 : 100 - _vm.score) + "%"
            }
          },
          [_c("div", { staticClass: "back" })]
        ),
        _vm._v(" "),
        _c("div")
      ])
    ]),
    _vm._v(" "),
    _vm.showTip
      ? _c("div", { staticClass: "tip" }, [_vm._v(_vm._s(_vm.tip))])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a3c3cede", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3c3cede","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mCircularProgress.vue
// module id = null
// module chunks = 